import { z } from 'zod';
import { IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * T9-011 — OutlookSubscription Zod shape.
 *
 * Mirrors the `outlook_subscriptions` Drizzle table EXCEPT `clientState`.
 * `clientState` is the shared secret echoed back by Microsoft Graph on every
 * notification and is the sole auth factor for the public webhook; it is
 * stored on the row but deliberately ABSENT from this entity shape (RIG-268)
 * so it can never cross the `toEntity` boundary onto a response. The webhook
 * compare reads the raw secret via the repo's internal
 * `findRowByGraphSubscriptionId` accessor instead.
 */
export const OutlookSubscriptionStatusSchema = z.enum([
    'active',
    'expired',
    'failed_renewal',
]);
export const OutlookSubscriptionSchema = z.object({
    id: IDSchema,
    type: z.literal('outlook_subscription'),
    schemaVersion: SchemaVersionSchema,
    repEmail: z.string().email(),
    graphSubscriptionId: z.string(),
    // clientState INTENTIONALLY OMITTED (RIG-268) — webhook shared secret; see
    // the file docstring. Read the raw value via findRowByGraphSubscriptionId.
    expiresAt: IsoTimestampSchema,
    status: OutlookSubscriptionStatusSchema,
    createdAt: IsoTimestampSchema,
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    version: z.number().int().positive(),
});
//# sourceMappingURL=outlook-subscription.js.map